import { render, staticRenderFns } from "./ResourceAssignedList.vue?vue&type=template&id=b4fa1b26&scoped=true&"
import script from "./ResourceAssignedList.vue?vue&type=script&lang=js&"
export * from "./ResourceAssignedList.vue?vue&type=script&lang=js&"
import style0 from "./ResourceAssignedList.vue?vue&type=style&index=0&id=b4fa1b26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fa1b26",
  null
  
)

export default component.exports